import { Link } from "react-router-dom";
import { useLanguage, useAuth } from "@/context/AppProviders";
import { FadeIn } from "@/components/Kinetic";
import { MessageCircle } from "lucide-react";

export const Footer = () => {
  const { t } = useLanguage();
  const { user } = useAuth();
  const waNumber = "33745423254";
  const waMsg = encodeURIComponent(t.formation.whatsappMsg);

  return (
    <footer className="border-t border-ink/10 bg-paper" data-testid="main-footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <FadeIn>
          <Link to={user ? "/espace-membre" : "/formation"} data-testid="footer-cta" className="group block">
            <h2 className="font-display font-semibold tracking-tighter leading-[0.95] text-5xl md:text-8xl text-ink">
              {t.footer.cta1}
              <br />
              <span className="font-serif italic font-light text-ember group-hover:text-emberlight transition-colors duration-500">{t.footer.cta2}</span>
            </h2>
          </Link>
        </FadeIn>
        <FadeIn delay={0.15} className="mt-10 flex flex-wrap items-center gap-4">
          <Link
            to={user ? "/espace-membre" : "/formation"}
            data-testid="footer-cta-btn"
            className="btn-glow inline-block bg-ink hover:bg-ember text-white px-8 py-4 text-sm tracking-wide transition-colors duration-300"
          >
            {t.footer.button}
          </Link>
          <a
            href={`https://wa.me/${waNumber}?text=${waMsg}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="inline-flex items-center gap-2 border border-ink/20 hover:border-ember hover:text-ember text-ink/70 px-8 py-4 text-sm tracking-wide transition-colors duration-300"
          >
            <MessageCircle size={16} /> {t.footer.contact}
          </a>
        </FadeIn>

        <div className="mt-24 pt-8 border-t border-ink/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="font-display font-semibold text-2xl text-ink">{t.brand}<span className="text-ember">.</span></p>
          <p className="text-sm text-ink/50">{t.footer.tagline}</p>
          <p className="text-xs text-ink/40" data-testid="footer-rights">{t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};
